import React from 'react'

import Text from 'components/typography/Text/Text'

import s from './CardTitle.scss'


const CardTitle = ({ title, color = 'white-80' }) => (
  <div className={s.title}>
    <Text
      message={title}
      size="30-36"
      color={color}
      weight="semibold"
    />
  </div>
)


export default CardTitle
